var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useMemo, useState } from 'react';
import { Input } from '@rocketseat/unform';
import { StyledAsyncSelect, StyledSelect } from './styles';
var SearchSelect = function (_a) {
    var placeholder = _a.placeholder, loadOptions = _a.loadOptions, name = _a.name, defaultValue = _a.defaultValue, noOptionsMessage = _a.noOptionsMessage, onChange = _a.onChange, onInputChange = _a.onInputChange, _b = _a.async, async = _b === void 0 ? true : _b, isSearch = _a.isSearch, value = _a.value, rest = __rest(_a, ["placeholder", "loadOptions", "name", "defaultValue", "noOptionsMessage", "onChange", "onInputChange", "async", "isSearch", "value"]);
    var _c = useState(defaultValue), currentValue = _c[0], setCurrentValue = _c[1];
    useEffect(function () {
        setCurrentValue(defaultValue);
    }, [defaultValue]);
    var inputValue = useMemo(function () { return currentValue === null || currentValue === void 0 ? void 0 : currentValue.value; }, [currentValue]);
    return (React.createElement(React.Fragment, null,
        async ? (React.createElement(StyledAsyncSelect, __assign({ placeholder: placeholder || '--', loadOptions: loadOptions ||
                function () {
                    return [];
                }, onChange: function (newValue) {
                setCurrentValue(newValue);
                if (onChange)
                    onChange(newValue);
            }, value: currentValue, noOptionsMessage: function () { return noOptionsMessage || 'Sem resultados'; } }, rest))) : (React.createElement(StyledSelect, __assign({ isSearch: isSearch, placeholder: placeholder || '--', options: loadOptions, onChange: function (newValue, a) {
                setCurrentValue(newValue);
                if (onChange)
                    onChange(newValue, a);
            }, onInputChange: function (value) { return onInputChange && onInputChange(value); }, noOptionsMessage: function () { return noOptionsMessage || 'Sem resultados'; }, value: currentValue }, rest))),
        React.createElement(Input, { name: name, value: inputValue || '', type: "hidden" })));
};
export default SearchSelect;
